import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { forkJoin, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { switchMap } from 'rxjs/operators';
import { NewsDetails } from '@fc-core/models/news-details.model';

export interface News {
  id: number;
  publishedAt: Date;
  title: string;
  body: string;
  image: string;
  imageWidth: number;
  imageHeight: number;
}

export interface Response {
  count: number;
  next?: any;
  previous?: any;
  results: any;
}

export interface NewsRaw {
  id: number;
  meta: {
    type: string;
    detail_url: string;
    html_url: string;
    slug: string;
    first_published_at: string;
  };
  title: string;
}

export interface NewsResponse {
  meta: { total_count: number };
  items: NewsRaw[];
}

@Injectable({
  providedIn: 'root',
})
export class NewsService {
  constructor(private http: HttpClient) {}

  getNews(): Observable<NewsDetails[]> {
    return this.http
      .get<NewsResponse>(
        environment.cmsUrl +
          'api/v2/articles/?category_title=Updates&order=-first_published_at',
      )
      .pipe(
        switchMap((resp) => {
          const requests = resp.items
            .sort(
              (a, b) =>
                new Date(b.meta.first_published_at).getTime() -
                new Date(a.meta.first_published_at).getTime(),
            )
            .map((item) => this.http.get<NewsDetails>(item.meta.detail_url));
          return forkJoin(requests);
        }),
      );
  }
}
